import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router, ActivatedRouteSnapshot, NavigationEnd, RoutesRecognized } from '@angular/router';
import { Title } from '@angular/platform-browser';
import {JhiLanguageHelper, MAX_YEAR, MIN_YEAR, TN_GLOBAL_OPTIONS} from './shared';
import { ReferenceTableService } from './reference-table.service';
import { AuthService} from './shared/services/auth.service';
import { DataService} from './shared/services/Data.service';
import {Idle, DEFAULT_INTERRUPTSOURCES} from '@ng-idle/core';
import {Keepalive} from '@ng-idle/keepalive';
import {HttpClient} from '@angular/common/http';

import * as $ from 'jquery';
import 'jquery-ui/ui/widgets/draggable.js';
import {NgbDatepickerConfig} from "@ng-bootstrap/ng-bootstrap";
import { SessionTimeoutModal } from './shared/modals/sessionTimeout.component';
import { SessionWarningModal } from './shared/modals/sessionWarning.component';
import { ModalPopupService } from './shared/modals/modal-popup/modal-popup.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [NgbDatepickerConfig]
})
export class AppComponent implements OnInit  {
    title = 'app';
    pageTitle = 'home';
    innerNav = '';
    refData: any;
    navRequired: boolean = true;
    userAuthenticated: boolean;
    tnGlobalOptions: any = TN_GLOBAL_OPTIONS;
    error:any = false;
    roles:any;

    constructor(
        private http: HttpClient,
        private jhiLanguageHelper: JhiLanguageHelper,
        private router: Router,
        private titleService: Title,
        private data: ReferenceTableService,
        private authService: AuthService,
        private activatedRoute: ActivatedRoute,
        private dataService: DataService,
        config: NgbDatepickerConfig,
        private idle: Idle, 
        private keepalive: Keepalive,
        private modalService: NgbModal,
        private modalpopService: ModalPopupService
    ) {
      // customize default values of datepickers used by this component tree
      config.minDate = {year: MIN_YEAR, month: 1, day: 1};
      config.maxDate = {year: MAX_YEAR, month: 12, day: 31};
      idle.setIdle(840);
      idle.setTimeout(60);
      idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
      idle.onTimeout.subscribe(() => {
        if(this.modalpopService.modelRef !== undefined){
            this.modalpopService.leavePage();
        }
        $("ngb-modal-window:visible").remove();
        $("ngb-modal-backdrop:visible").remove();
        modalService.open(SessionTimeoutModal, { centered: true, size: 'lg' });
      });
      idle.onTimeoutWarning.subscribe((countdown) => {
        if(this.modalpopService.modelRef !== undefined){
            this.modalpopService.leavePage();
        }
        $("ngb-modal-window:visible").remove();
        $("ngb-modal-backdrop:visible").remove();
        modalService.open(SessionWarningModal, { centered: true, size: 'lg' });

      });
      this.reset();
    }

    private getPageTitle(routeSnapshot: ActivatedRouteSnapshot) {
        let title: string = (routeSnapshot.data && routeSnapshot.data['pageTitle']) ? routeSnapshot.data['pageTitle'] : 'workRequirementApp';
        if (routeSnapshot.firstChild) {
            title = this.getPageTitle(routeSnapshot.firstChild) || title;
        }
        this.pageTitle = title;
        if (title === 'home.title') {
            this.pageTitle = 'home';
            this.innerNav = '';
        }else {
            if (title.includes('workRequirementApp.')) {
                if (title.includes('workRequirementApp.tasks')) {
                     this.innerNav = '';
                }else {
                    this.innerNav = 'inner';
                }
            }else {
                this.innerNav = 'came in else inner';
            }
            this.pageTitle = 'test';
        }
        return title;
    }

    ngOnInit() {
        //Events: Listener for Router events
        this.router.events.subscribe((event) => {
            //Event: When route navigation has ended
            if(event instanceof NavigationEnd) {
                if(event.url === "/404" || event.url ==="/"){
                    this.error = true;
                }
                //If authenticated, retrieve reference tables
                if(this.authService.isAuthenticated()===true){
                  /*this.data.loadData();
                  this.data.currentMessage.subscribe(
                    (message) => {
                      this.data.parseRefTableData(message);
                  });*/
                }
                //Update title
                this.jhiLanguageHelper.updateTitle(this.getPageTitle(this.router.routerState.snapshot.root));
            }

            //Retrieve route data. Reference: https://stackoverflow.com/questions/40863664/how-to-get-current-route-custom-data-in-angular-2
            if(event instanceof RoutesRecognized) {
              this.navRequired = (event.state.root.firstChild.data['navRequired'] !== undefined) ? event.state.root.firstChild.data['navRequired'] : true;
            }

            /* Checks if the user has been authenticated, so chatbot can be displayed */
           this.userAuthenticated = this.authService.isAuthenticated();
        });

        // Added draggable event for chatbot
        this.chatbotDraggable();
    }
    reset() {
        this.idle.watch();
      }

    /* Display chatbot main container */
    displayChatbotWindow(){
        $("#chatbotMainContainer").show();
        $("#chatbotMainContainerBtn").hide();
    }

    /**
     * Added drag & drop event to the chatbot sticky button & chatbot window
     */
    chatbotDraggable(){
        $(function() {
            // Add drag & drop event to the Chatbot window
            ($( "#chatbotMainContainer") as any).draggable();

            // Add drag & drop event to the Chatbot sticky button
            ($('#chatbotMainContainerBtn') as any).draggable();

            /* Add click event event to the Chatbot sticky button
             * - 1. added drag & drop, to immediately stop click propagation
             * - 2. added click event, so the element can be listening for single click
             */
            $('#chatbotMainContainerBtn').click(() => {
                $("#chatbotMainContainer").show();
                $('#chatbotMainContainerBtn').hide();
            });
        });
    }
    ngAfterViewInit():void{
        this.roles = this.dataService.getSharedDataObject().get('roles');
        let isProvider = false;
        if(this.roles != undefined ){
            for( const role of this.roles){
                if( role.id === 5  ){
                    isProvider = true;
                    break;
                }
            }
        }
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) { 
                console.log((<any>window).ga);
                if(isProvider){
                    (<any>window).ga('set', 'page', "Provider Portal - " + event.urlAfterRedirects);
                }
                else{
                    (<any>window).ga('set', 'page', "Worker Portal - " + event.urlAfterRedirects);
                }
            
            if(event.url === '/'){
                (<any>window).ga('set', 'title', "Home Page");
                (<any>window).ga('send', 'pageview');
            }
            else{
                (<any>window).ga('set', 'title', "Citizen Portal" + event.url.substr(1));
                (<any>window).ga('send', 'pageview');
            }
            }
        });
    } 
 


}



// WEBPACK FOOTER //
// ./src/app/app.component.ts